import React from 'react';
import MUIDataTable from 'mui-datatables';
import { Localizacion } from 'lib.front';
import { formatFecha } from '../../utils/constans/formatFecha';

const options = {
    filter: false,
    selectableRows: 'none',
    expandableRowsHeader: false,
    pagination: true,
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15, 100],
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    fixedHeader: false,
    selectToolbarPlacement: 'none',
    selectableRowsOnClick: false,
    textLabels: Localizacion.muiDataTables.ES
};

const AbonosDetalleTable = ({
    data,
    fechaPeriodoDesde,
    fechaPeriodoHasta
}) => {
    const column = [
        {
            name: 'cantidad',
            label: 'Cantidad',
            options: {
                sort: true,
                display: true
            }
        },
        {
            name: 'codUnidadMedida',
            label: 'Und. Medida',
            options: {
                sort: true,
                display: true
            }
        },
        {
            name: 'descArticulo',
            label: 'Producto/Servicio',
            options: {
                sort: true,
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const periodo = fechaPeriodoDesde && fechaPeriodoHasta ? `${formatFecha(fechaPeriodoDesde)} - ${formatFecha(fechaPeriodoHasta)}` : null;
                    return periodo ? `${value} ${periodo}` : value
                }
            }
        },
        {
            name: 'precioUnitario',
            label: 'Precio U.',
            options: {
                sort: true,
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return value.toFixed(2)
                }
            }
        },
        {
            name: 'totalArticulo',
            label: 'Precio Total',
            options: {
                sort: true,
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return value.toFixed(2)
                }
            }
        }
    ];

    return (
        <MUIDataTable
            options={options}
            columns={column}
            data={data}
        />
    );
};
export default AbonosDetalleTable